import { DetailsRow, IDetailsRowProps } from "@bps/fluent-ui";

export interface DeploymentRingTableRowProps extends IDetailsRowProps {}

export const DeploymentRingTableRow = (props: DeploymentRingTableRowProps) => {
  const { item, ...rest } = props;

  const { sortOrder } = item;

  const row = {
    ...rest,
    item: {
      ...item,
      sortOrder
    }
  } as IDetailsRowProps;

  return <DetailsRow {...row} />;
};
